<template>
  <header class="navbar">
    <div class="navbar__left">
      <button
        type="button"
        class="sidebar-toggle"
        :aria-label="sidebar.opened ? '收起菜单' : '展开菜单'"
        :aria-expanded="sidebar.opened ? 'true' : 'false'"
        @click="toggleSideBar"
      >
        <!-- 点击统一由按钮处理，避免图标事件冒泡导致重复切换。 -->
        <hamburger :isActive="sidebar.opened"></hamburger>
      </button>
      <div class="breadcrumb-wrap">
        <breadcrumb></breadcrumb>
      </div>
    </div>

    <div class="navbar__right">
      <div class="workspace-status">
        <span class="workspace-status__dot"></span>
        <span>工作空间在线</span>
      </div>

      <el-dropdown class="user-menu" trigger="click" @command="handleCommand">
        <button type="button" class="user-trigger" aria-label="打开用户菜单">
          <span v-if="showAvatar" class="user-avatar">
            <img :src="avatar" alt="用户头像" @error="avatarFailed = true" />
          </span>
          <span v-else class="user-avatar user-avatar--fallback">{{ userInitial }}</span>
          <span class="user-meta">
            <strong>{{ name || '管理员' }}</strong>
            <small>系统管理员</small>
          </span>
          <i class="el-icon-arrow-down user-trigger__arrow"></i>
        </button>
        <el-dropdown-menu class="user-dropdown" slot="dropdown">
          <el-dropdown-item command="home" icon="el-icon-s-home">返回首页</el-dropdown-item>
          <el-dropdown-item command="logout" icon="el-icon-switch-button" divided>退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </header>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'

export default {
  components: {
    Breadcrumb,
    Hamburger
  },
  data() {
    return {
      avatarFailed: false
    }
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar',
      'name'
    ]),
    showAvatar() {
      return Boolean(this.avatar) && !this.avatarFailed
    },
    userInitial() {
      return (this.name || '管').slice(0, 1).toUpperCase()
    }
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('ToggleSideBar')
    },
    handleCommand(command) {
      if (command === 'home') {
        this.$router.push('/')
      }
      if (command === 'logout') {
        this.logout()
      }
    },
    logout() {
      this.$store.dispatch('LogOut').then(() => {
        location.reload() // 为了重新实例化vue-router对象 避免bug
      })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 70px;
  padding: 0 28px 0 20px;
  border-bottom: 1px solid #e5ebe5;
  background: rgba(255, 255, 255, 0.94);
  box-shadow: 0 4px 18px rgba(39, 83, 52, 0.04);

  &__left,
  &__right {
    display: flex;
    align-items: center;
    min-width: 0;
  }

  &__right {
    gap: 24px;
  }
}

.sidebar-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  margin-right: 13px;
  padding: 0;
  border: 0;
  color: #365344;
  border-radius: 10px;
  background: transparent;
  cursor: pointer;
  transition: background 0.2s ease;
}

.sidebar-toggle:hover {
  background: #eef6ef;
}

.breadcrumb-wrap {
  min-width: 0;
}

.workspace-status {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #84938a;
  font-size: 12px;
  white-space: nowrap;
}

.workspace-status__dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #58b76c;
  box-shadow: 0 0 0 4px rgba(88, 183, 108, 0.12);
}

.user-menu {
  height: 44px;
}

.user-trigger {
  display: flex;
  align-items: center;
  height: 44px;
  padding: 0;
  border: 0;
  color: #25382c;
  background: transparent;
  cursor: pointer;
}

.user-avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  overflow: hidden;
  border-radius: 11px;
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  background: linear-gradient(135deg, #72c782, #2f7b4b);
}

.user-avatar img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.user-meta {
  display: flex;
  flex-direction: column;
  gap: 3px;
  margin-left: 10px;
  text-align: left;
}

.user-meta strong {
  max-width: 110px;
  overflow: hidden;
  font-size: 13px;
  font-weight: 650;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.user-meta small {
  color: #9aa79e;
  font-size: 10px;
}

.user-trigger__arrow {
  margin-left: 11px;
  color: #9aa79e;
  font-size: 12px;
}

@media (max-width: 720px) {
  .navbar {
    height: 64px;
    padding: 0 16px;

    &__right {
      gap: 0;
    }
  }

  .workspace-status,
  .user-meta,
  .user-trigger__arrow {
    display: none;
  }

  .user-avatar {
    width: 32px;
    height: 32px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue